<template>
  <div class="main_right fr">
    <div class="location">
      当前位置：
      <router-link :to="{path:'/list'}" class="a">首页</router-link>&nbsp;&gt;&nbsp;
      <router-link :to="{path:'/list'}" class="a">{{currentIdName}}</router-link>
    </div>
    <!-- #useImg：列表右侧顶部图片，.list中的style：配合#useImg,图片下架时需要删掉  -->
    <div class="list" style="position: relative;padding-top:80px" v-if="currentId === undefined && currentIdName === undefined">
      <!-- <a href="https://zhuanti.drcnet.com.cn/partyBuildingList?leafId=30289&text=%E5%9B%BD%E7%A0%94%E8%A7%A3%E8%AF%BB"> -->
      <a href="https://zhuanti.drcnet.com.cn/2025FourthPlenumList?leafId=31898&text=%E5%9B%BD%E7%A0%94%E8%A7%A3%E8%AF%BB" target="_blank">
      <!-- <img id="useImg" src="../../assets/imgs/GuoYanJieDu.jpg" style="position:absolute;top:0;right:0"> -->
      <img id="useImg" src="../../assets/imgs/GuoYanJieDu2.png" style="position:absolute;top:0;right:0">
    </a>
      <div v-for="(items,index) in indexDocsData" :key="index">
        <div class="list_title clearfix">
          <span class="list_titleL fl">{{items.text}}</span>
          <router-link
            class="list_titleR fr"
            :to="{path:'/list',query:{uid:items.id, uidname:items.text}}"
          >更多 ></router-link>
        </div>
        <ul>
          <li v-for="item in items.data" :key="item.code">
            <div class="clearfix">
              <!-- <router-link
                :to="{path:'/detail',query:{docid:(item.code || '').substring(4,(item.code || '').length),leafid:item.leafid}}"
                target="_blank"
                class="sub fl"
                :title="item.title"
              >· {{item.title}}</router-link> -->
              <router-link
                :to="{path:'/detail',query:{docid:(item.code || '').substring(4,(item.code || '').length),leafid:item.leafid}}"
                target="_blank"
                class="sub fl"
                :title="item.title"
              >· {{item.title}}</router-link>
              <div class="date fr" v-show="items.id !== '0203'">{{item.deliveddate}}</div>
              <div class="date fr" v-show="items.id === '0203'">{{item.source}}</div>
            </div>
            <div class="text">
              <span :title="item.summary">{{item.summary | summaryEllipsis}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="list lists"  v-else>
      <ul>
        <li v-for="item in indexDocsData" :key="item.code">
          <div class="clearfix">
            <router-link
              :to="{path:'/detail',query:{docid:(item.code || '').substring(4,(item.code || '').length),leafid:item.leafid}}"
              target="_blank"
              class="sub fl"
              id="subs"
              :title="item.title"
            >· {{item.title}}</router-link>
            <div class="date fr">{{item.deliveddate}}</div>
            <div class="date fr" v-show="currentId === '0203'">{{item.source}}</div>
          </div>

          <div class="text" id="texts">
            <span :title="item.summary">{{item.summary | summaryEllipsis}}</span>
          </div>
        </li>
      </ul>
      <div v-if="!total" style="color: #333;font-size: 15px;">系统维护中...</div>
      <el-pagination
        v-show="total"
        background
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :current-page="currentPage"
        layout="prev, pager, next, jumper, total"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 后期添加的可视化图 -->
    <ul class="echarts clearfix" v-if="currentId === undefined || currentIdName === undefined">
      <li class="fl hotword">
        <h1>领域热词</h1>
        <Echarts class="fl" :option="setOption" />
      </li>
      <li class="fr result">
        <h1>领域成果</h1>
        <div class="fl" id="lineChart"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import Echarts from "@/components/echarts";
export default {
  components: {
    Echarts
  },
  data() {
    return {
      indexDocsData: [],
      total: 0,
      currentId: undefined,
      currentIdName: undefined,
      currentPage: 1,
      pagesize: 5,
      setOption: {
        type: "wordCloud",
        gridSize: 5, //用来调整词之间的距离
        sizeRange: [11, 40], //用来调整字的大小范围
        width: 300,
        height: 230,
        textStyle: {
          normal: {
            color: function() {
              var colors = [
                "#f9863a",
                "#976dd1",
                "#35c0d6",
                "#2697ed",
                "#735f5f",
                "#6e9dc7",
                "#9f9f9f",
                "#33aff2"
              ];
              return colors[parseInt(Math.random() * 8)];
            }
          }
        },
        top: 20,
        left: 10,
        data: []
      }
    };
  },
  created() {
    for (let key in this.$route.query) {
      if (key.toLowerCase() === "uid") {
        this.currentId = this.$route.query[key];
      } else if (key.toLowerCase() === "uidname") {
        this.currentIdName = this.$route.query[key];
      }
    }
    this.currentId == undefined && this.currentIdName == undefined
      ? (this.pagesize = 3)
      : this.currentId == "02"
      ? (this.pagesize = 6)
      : (this.pagesize = 10);
    if (this.currentId == "01") {
      this.loadGYZGDocs();
    } else if (
      this.currentIdName !== undefined &&
      this.currentId === undefined
    ) {
      this.loadShowTypeDocs();
    } else {
      let fullPath = this.$route.fullPath.toLowerCase() === "/list",
        param =
          this.currentId !== undefined && this.currentIdName === undefined;
      if (fullPath || param) {
        this.lineChart();
      }
      this.currentId ? this.loadIndexDocs() : this.loadIndexDoc()
    }
    this.currentPage = 1;
  },
  filters: {
    //文章标题截取
    summaryEllipsis(value) {
      if (!value) return "";
      if (value.length > 128) {
        return value.slice(0, 128) + "...";
      }
      return value;
    }
  },
  methods: {
    async loadIndexDocs() {
      const { code, data } = await this.$api.get(
        "NewViewSecondController/viewpoint/getSecondDocs",
        {
          uid: this.currentId,
          currpage: this.currentPage,
          pagesize: this.pagesize,
        }
      );
      if (code === 0) {
          this.indexDocsData = data.data;
          this.total = data.count;
        }
      // }
    },
    async loadIndexDoc() {
      const { code, data } = await this.$api.get(
        "NewViewSecondController/viewpoint/getSecondDocs",
        {
          uid: this.currentId,
          currpage: this.currentPage,
          pagesize: this.pagesize
        }
      );
      if (code === 0) {
        if (this.currentId == undefined) {
          this.indexDocsData = data;
        }
      }
    },
    // 国研专稿
    async loadGYZGDocs() {
      const { code, data } = await this.$api.get(
        "NewViewSecondController/viewpoint/getSecondGYZGDocs",
        {
          currpage: this.currentPage,
          pagesize: this.pagesize
        }
      );
      if (code === 0) {
        this.indexDocsData = data.data;
        this.total = data.totlalCount;
      }
    },
    // 首页资源展示的文章
    async loadShowTypeDocs() {
      const { code, data } = await this.$api.get(
        "NewViewIndexController/viewpoint/getResShowTypeDocs",
        {
          curpage: this.currentPage,
          pagesize: this.pagesize,
          docClass: this.currentIdName
        }
      );
      if (code === 0) {
        this.indexDocsData = data.data;
        this.total = data.totlalCount;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.currentId == "01") {
        this.loadGYZGDocs();
      } else if (
        this.currentIdName !== undefined &&
        this.currentId === undefined
      ) {
        this.loadShowTypeDocs();
      } else {
        this.loadIndexDocs();
      }
    },
    // 【 后期添加可视化图 】
    // 折线图
    async lineChart() {
      const { code, data } = await this.$api.get(
        "NewViewIndexController/viewpoint/getIndexTrendChart",
        {
          uid: "02"
        }
      );
      if (code === 0) {
        let legends = [],
          series = [];
        data.linedata.forEach(item => {
          legends.push(item.tagname);
          series.push({
            name: item.tagname,
            type: "line",
            data: item.data
          });
        });
        let lineChart = this.$echarts.init(
          document.getElementById("lineChart")
        );
        lineChart.setOption({
          color: [
            "#EC635F",
            "#0EB3F0",
            "#ED904B",
            "#3CC5CE",
            "#9E61C5",
            "#2B86E2",
            "#60B32E",
            "#A0A0A0",
            "#857DC3",
            "#F1CC02",
            "#C9A998",
            "#F768A8"
          ],
          grid: {
            top: 80,
            left: 20,
            right: 20,
            bottom: 0,
            containLabel: true
          },
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: legends,
            top: 12,
            left: 0,
            itemWidth: 14,
            itemHeight: 10,
            textStyle: {
              fontStyle: 11
            }
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: data.year
          },
          yAxis: {
            type: "value"
          },
          series: series
        });
      }
    }
  },
  watch: {
    $route() {
      this.currentId = undefined;
      this.currentIdName = undefined;
      for (let key in this.$route.query) {
        if (key.toLowerCase() === "uid") {
          this.currentId = this.$route.query[key];
        } else if (key.toLowerCase() === "uidname") {
          this.currentIdName = this.$route.query[key];
        }
      }
      this.currentId == undefined && this.currentIdName == undefined
        ? (this.pagesize = 3)
        : this.currentId == "02"
        ? (this.pagesize = 6)
        : (this.pagesize = 10);
      if (this.currentId == "01") {
        this.loadGYZGDocs();
      } else if (
        this.currentIdName !== undefined &&
        this.currentId === undefined
      ) {
        this.loadShowTypeDocs();
      } else {
        let fullPath = this.$route.fullPath.toLowerCase() === "/list",
          param =
            this.currentId !== undefined && this.currentIdName === undefined;
        if (fullPath || param) {
          this.lineChart();
        }
        this.currentId ? this.loadIndexDocs() : this.loadIndexDoc()
      }
      this.currentPage = 1;
    }
  }
};
</script>

<style lang='less' scoped>
.main_right {
  width: 900px;
  .location {
    a {
      color: #666;
    }
    a:hover {
      color: #2b86e2;
    }
  }
  .list {
    background: #fff;
    padding: 20px 30px;
    margin-top: 15px;
    .list_title {
      padding: 10px 10px 0 10px;
      margin-bottom: 10px;
      border-bottom: 1px dotted #ccc;
      line-height: 32px;
      .list_titleL {
        font-size: 15px;
        color: #2b86e2;
        font-weight: 700;
      }
      .list_titleL::before {
        content: "";
        display: inline-block;
        width: 20px;
        height: 24px;
        background: url(../../assets/imgs/imgicon.png) no-repeat;
      }
      .list_titleR {
        color: #999 !important;
        font-size: 14px;
        line-height: 34px;
      }
    }
    ul {
      padding-right: 10px;
      .sub {
        width: 600px;
        text-align: left;
        line-height: 32px;
        padding: 3px 0;
        color: #000;
        font-family: "宋体";
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .sub:hover {
        color: #2b86e2;
      }
      .date {
        float: right;
        height: 32px;
        line-height: 34px;
        color: Gray;
        font-size: 14px;
      }
      .text {
        text-align: left;
        color: Gray;
        padding-left: 21px;
        text-indent: 2em;
        font-size: 12px;
        padding-bottom: 10px;
        line-height: 150%;
        span {
          height: 36px;
          color: #999;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  .lists {
    padding: 28px 30px;
    #subs {
      line-height: 34px;
    }
    #texts {
      padding-bottom: 13px;
    }
  }
  .el-pagination {
    margin-top: 46px;
  }
}
.echarts {
  background: #fff;
  width: 900px;
  height: 320px;
  margin-top: 10px;
  padding: 13px 32px 0px 36px;
  li {
    h1 {
      border-bottom: 1px solid rgba(232, 234, 239, 1);
      width: 100%;
      font-size: 15px;
      color: #333333;
      line-height: 35px;
    }
  }
  .hotword {
    width: 40%;
    /deep/#wordCloud {
      width: 332px;
      height: 250px;
    }
  }
  .result {
    width: 56%;
    #lineChart {
      width: 100%;
      height: 250px;
    }
  }
}
</style>